import React, { useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  Box,
  Button,
  Container,
  TextField,
  makeStyles,
  Typography,
  CardContent,
  Card,
  CardMedia,
  Grid,
} from "@material-ui/core";
import GoogleAuth from "./GoogleAuth";
import Page from "components/Page";
import ServiciosUser from "utils/ServiciosUser";
import logodash from "assets/logo dashboard blanco.svg";
import logoti from "assets/logo ti blanco.svg";
const schema = {
  usuario: {
    presence: { allowEmpty: false, message: "is required" },
  },
  password: {
    presence: { allowEmpty: false, message: "is required" },
  },
};

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(6, 2),
  },
  card: {
    width: theme.breakpoints.values.md,
    backgroundColor: "#2d3239",
    color: "white",
    maxWidth: "100%",
    overflow: "unset",
    display: "flex",
    position: "relative",
    borderRadius: "15px",
    "& > *": {
      flexGrow: 1,
      flexBasis: "50%",
      width: "50%",
    },
  },
  principal: {
    backgroundImage:
      "linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3) ), url(https://maderascrm.gphsis.com/dist/img/banner-principal-terrenos-ciudad-maderas.webp)",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    position: "relative",
    height: "100vh",
  },
  content: {
    borderRadius: "10px",
    backgroundColor: "rgb(255,255,255)",
    color: "white",
    textAlign: "center",
    color: "#AEA16E",
  },
  media: {
    backgroundColor: "#2d3239",
    padding: "3%",
    color: theme.palette.white,
    justifyContent: "center",
    borderRadius: "10px",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    textAlign: "center",
    color: "#AEA16E",
  },
  loginForm: {
    marginTop: theme.spacing(3),
  },
  person: {
    marginTop: theme.spacing(2),
    display: "flex",
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
  button: {
    backgroundColor: "#2d3239",
  },
  footer: {
    bottom: "0px",
    left: 0,
    position: "absolute",
    width: "99%",
    textAlign: "right",
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
}));

const LoginView = () => {
  const classes = useStyles();
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ open: false });
  const navigate = useNavigate();
  const login = (values, accion) => {
    ServiciosUser.login(
      (status, mensaje, data) => {
        if (status > 0) {
          localStorage.setItem("idrol", data.idrol);
          localStorage.setItem("token", data.token);
          window.location.reload(true);
        } else {
          // console.log(mensaje);
          setMensaje({ open: true, status: status, value: mensaje });
          accion.resetForm();
        }
      },
      setCargando,
      { data: values }
    );
  };
  //Validar que el email este activado para google
  const validarEmailEmpresarial = (values) => {
    ServiciosUser.validarRegistroEmailEmpresarial(
      (estado, mensaje, data) => {
        const status = data?.data?.status;
        console.log(data.data);
        // No ha verificado correo de empresarial
        if (status == -2) {
          setMensaje({ open: true, status: 1, value: mensaje });
          localStorage.setItem("user", data?.data?.idUsuario);
          setTimeout(() => {
            navigate("/autenticacion"); // Redirigir después del tiempo de espera
          }, 4000);
        } else if (status == 2) {
          setMensaje({ open: true, status: 1, value: mensaje });
        } else {
          setMensaje({ open: true, status: -1, value: mensaje });
        }
      },
      setCargando,
      { data: values }
    );
  };

  const handleLoginSuccess = (user) => {
    ServiciosUser.loginGmail(
      (status, mensaje, data) => {
        if (status > 0) {
          localStorage.setItem("idrol", data.idrol);
          localStorage.setItem("token", data.token);
          window.location.reload(true);
        } else {
          setMensaje({ open: true, status: status, value: mensaje });
        }
      },
      setCargando,
      { data: user }
    );
  };

  const handleLoginError = (error) => {
    setMensaje({
      open: true,
      status: -1,
      value:
        "Error en la autenticación con Google, por favor contacte a soporte.",
    });
  };

  return (
    <Page
      className={classes.root}
      title="Bienvenido"
      cargando={cargando}
      mensaje={{ ...mensaje, cerrar: (event) => setMensaje({ open: false }) }}
    >
      <Card className={classes.card}>
        <CardMedia className={classes.media}>
          <img
            src={logodash}
            width="100%"
            style={{ height: "10vh", marginBottom: "100px" }}
          />
          <img src={logoti} width="100%" style={{ height: "10vh" }} />
        </CardMedia>
        <CardContent className={classes.content}>
          <Typography
            gutterBottom
            variant="h3"
            style={{
              fontFamily: "Trojan Bold",
              color: "#AEA16E",
              fontSize: "36px",
            }}
          >
            ¡BIENVENIDO!
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ fontSize: "14px", color: "black" }}
          >
            Inicia sesión para acceder a su cuenta
          </Typography>
          <br></br>
          <Container maxWidth="sm">
            <GoogleAuth
              onLoginSuccess={handleLoginSuccess}
              onLoginError={handleLoginError}
            />
            <hr style={{ marginTop: "16px" }} />
          </Container>

          {/* <LoginForm id="login-form" className={classes.loginForm} /> */}
          <div>
            <Box
              display="flex"
              flexDirection="column"
              height="100%"
              justifyContent="center"
            >
              <Container maxWidth="sm">
                <Formik
                  initialValues={{
                    usuario: "",
                    password: "",
                  }}
                  validationSchema={Yup.object().shape({
                    usuario: Yup.string()
                      .max(255)
                      .required("Campo requerido"),
                    password: Yup.string()
                      .max(255)
                      .required("Campo requerido"),
                  })}
                  // onSubmit={login}
                  onSubmit={validarEmailEmpresarial}
                >
                  {({
                    errors,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    touched,
                    values,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <Box mt={3} mb={1}></Box>
                      <TextField
                        error={Boolean(touched.usuario && errors.usuario)}
                        fullWidth
                        helperText={touched.usuario && errors.usuario}
                        label="Usuario"
                        margin="normal"
                        name="usuario"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.usuario}
                        variant="outlined"
                        InputProps={{
                          style: {
                            color: "black", // Color del texto
                          },
                        }}
                      />
                      <TextField
                        error={Boolean(touched.password && errors.password)}
                        fullWidth
                        helperText={touched.password && errors.password}
                        label="Contraseña"
                        margin="normal"
                        name="password"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type="password"
                        value={values.password}
                        variant="outlined"
                        InputProps={{
                          style: {
                            color: "black", // Color del texto
                          },
                        }}
                      />
                      <Box my={2}>
                        <Button
                          color="primary"
                          fullWidth
                          size="large"
                          type="submit"
                          variant="contained"
                          className={classes.button}
                        >
                          ENTRAR
                        </Button>
                      </Box>
                    </form>
                  )}
                </Formik>
              </Container>
            </Box>
          </div>
        </CardContent>
      </Card>
      <Grid item xs={12} className={classes.footer}>
        <Typography variant="body1" style={{ color: "#7b7f82" }}>
          © {new Date().getFullYear()}{" "}
          <a
            href="https://ciudadmaderas.com"
            target="_blank"
            style={{ color: "#3c8dbc", display: "inline-block" }}
          >
            Ciudad Maderas
          </a>
          . Departamento de TI
        </Typography>
      </Grid>
    </Page>
  );
};

export default LoginView;
